$(document).ready(function () {
    var $formButtons = '',
        $captchaWrapper = '',
        $infoBoxError = '',
        addressState = '',
        $mailingListToggle = '',
        $mailingListWrapper = '';

    if ($('.addresses').length) {
        $formButtons = $('.addresses').closest('#personalInformationForm').find('.form-btn');
        $captchaWrapper = $('.addresses').closest('#personalInformationForm').find('.g-recaptcha');
        $infoBoxError = $('.addresses').closest('#personalInformationForm').find('.infoBox .error');
        addressState = $('.switch-address').val();
        $mailingListToggle = $('.mailing-list-toggle');
        $mailingListWrapper = $('.mailing-list-wrapper');
        $mailingListToggle.prop('checked') ? $mailingListWrapper.addClass('js--open') : '';

        $mailingListToggle.on('change', function () {
            $mailingListToggle.prop('checked')
                ? $mailingListWrapper.addClass('js--open')
                : $mailingListWrapper.removeClass('js--open');
        });

        if (!addressState || $infoBoxError.length) {
            $formButtons.show();
            $captchaWrapper.removeClass('hidden');
        } else {
            $formButtons.hide();
            $captchaWrapper.addClass('hidden');
        }

        $('.switch-address').on('change', function () {
            var addressState = $('.switch-address').val();

            if (!addressState) {
                $formButtons.show();
                $captchaWrapper.removeClass('hidden');
            } else {
                $formButtons.hide();
                $captchaWrapper.addClass('hidden');
            }
        });

        $('.edit-address').on('click', function () {
            var addressState = $('.switch-address').val();

            if (!addressState) {
                $formButtons.hide();
                $captchaWrapper.addClass('hidden');
            } else {
                $formButtons.show();
                $captchaWrapper.removeClass('hidden');
            }
        });
    }
});

const errorFocusController = (errorList, errorDetailsContainer) => {
    const formContainer = document.getElementById('personalInformationForm');
    const addressErrorFields = [];
    const recaptchaCheckbox = document.querySelector('.g-recaptcha iframe');
    const clearFormBtn = formContainer?.querySelector('.actions a.linkBtn');
    const submitFormBtn = formContainer?.querySelector('.actions input[type=submit]');
    const formFields = document
        .getElementById('address')
        ?.querySelectorAll('input[id^="address"], select[id^="address"]:not([disabled="disabled"])');

    const focusController = (formFields, exitTrapFlag) => {
        formFields?.forEach(field => {
            const errorLabel = field?.previousElementSibling;
            if (errorLabel && errorLabel.classList.contains('label')) {
                field.setAttribute(
                    'tabindex',
                    (exitTrapFlag && !errorLabel.classList.contains('error')) || errorLabel.classList.contains('error')
                        ? '0'
                        : '-1'
                );

                if (errorLabel.classList.contains('error')) {
                    addressErrorFields.push(field);
                }
            }
        });
        recaptchaCheckbox?.setAttribute('tabindex', '0');
    };

    focusController(formFields);
    addressErrorFields?.push(recaptchaCheckbox, clearFormBtn, submitFormBtn);

    const lastErrorItem = errorDetailsContainer?.querySelector('li:last-child');

    const handleTabKey = event => {
        if (event.key === 'Tab') {
            event.preventDefault();

            const currentElement = addressErrorFields?.findIndex(element => document.activeElement === element);
            let nextElement = currentElement + (event.shiftKey ? -1 : 1);

            if (nextElement < 0) {
                nextElement = addressErrorFields?.length - 1;
            } else if (nextElement >= addressErrorFields?.length) {
                nextElement = 0;
            }
            addressErrorFields[nextElement]?.focus();
        } else if (event.key !== 'Tab') {
            focusController(formFields, 1);
            document.removeEventListener('keydown', handleTabKey);
        }
    };

    lastErrorItem?.addEventListener('focus', () => {
        document.addEventListener('keydown', handleTabKey);
    });
};
const showErrorBox = () => {
    const errorLabels = document.querySelectorAll('.label.error');

    if (errorLabels.length > 0) {
        const errorContainer = document.querySelector('fieldset .infoBox');
        const errorDetailsContainer = document.createElement('ul');
        const errorList = [];
        errorDetailsContainer.setAttribute('id', 'errorSummaryBox');

        errorLabels.forEach(errorMessage => {
            const errorTxt1 = errorMessage?.querySelector('label').innerText;
            const errorTxt2 = errorMessage?.querySelector('.message').innerText;
            const error = (errorTxt1 + errorTxt2).replace(/\*/g, '');
            const errorFieldID = errorMessage?.nextElementSibling.getAttribute('id');
            const errorDetails = document.createElement('li');

            errorList?.push(errorFieldID);
            errorDetails.setAttribute('tabindex', '0');
            errorDetails.innerText = error;
            errorDetailsContainer.append(errorDetails);
        });
        errorContainer?.append(errorDetailsContainer);
        errorContainer?.setAttribute('tabindex', '0');
        errorContainer?.focus();
        errorFocusController(errorList, errorDetailsContainer);
    }
};

$(window).load(function () {
    var addressAccordion = $('.addresses-accordion .accordion__control');
    const addressEl = document.getElementById('address');
    if ($('.accordion__content #address .label').hasClass('error')) {
        UX.accordion.on.toggle.single(addressAccordion);
    }

    if (addressEl) {
        showErrorBox();
    }
});
